import styled, { css } from 'styled-components';
import Text from '@components/text';
import { generateScales } from '@helpers/generate-media-queries';

export const Constraint = styled.div`
  max-width: 720px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    row-gap: 1rem;
  }
`;

export const Subheading = styled(Text)<{ position?: string }>`
  display: block;
  max-width: 38rem;
  margin: 0 auto;
  color: ${({ theme }) => theme.colors.white};

  ${({ theme }) => css`
    ${generateScales('font-size', '1.125rem', '1.375rem', theme)}

    p + p {
      ${generateScales('margin-top', '1rem', '1.5rem', theme)}
    }
  `}
`;

export const StyledHeader = styled.header`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.secondary};
    row-gap: 2.75rem;
    text-align: center;
    width: 100%;
    position: relative;
    padding-bottom: 4rem;
    padding-top: calc(5rem + 5rem);
    z-index: 10;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      row-gap: 2.5rem;
      padding-top: calc(3.5rem + 4rem);
      padding-bottom: 3.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      row-gap: 2rem;
      padding-top: calc(3rem + 4rem);
      padding-bottom: 3rem;
  `}
`;
